import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ApiClientService, Sms_ponudum } from '../../../services/api-client.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-mobilne-ponude',
  templateUrl: './mobilne-ponude.component.html',
  styleUrls: ['./mobilne-ponude.component.scss']
})
export class MobilnePonudeComponent implements OnInit {
  constructor(
    private apiClient: ApiClientService,
    private cdRef: ChangeDetectorRef,
    private userService: UserService
  ) {
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
  }

  countries: any[] = [];
  selectedCountry: string = '';
  startDate: Date = new Date(new Date().toDateString());
  endDate: Date = new Date(new Date(new Date().toDateString()).setHours(23, 59, 59, 999));
  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#mobilnaPonudeGrid' };
  createMobilnaPonudaPopupVisible: boolean = false;
  editMobilnaPonudaPopupVisible: boolean = false;
  isUserModerator: boolean = false;
  selectedMobilnaPonuda: Sms_ponudum;

  @ViewChild('mobilnaPonudeGrid', { static: false }) mobilnaPonudeGrid: DxDataGridComponent;

  ngOnInit() {
    this.initializeCountries();
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
  }

  initializeCountries() {
    this.countries = [
      { code: 'BiH', name: 'Bosna i Hercegovina' },
      { code: 'Srb', name: 'Srbija' },
      { code: 'Hrv', name: 'Hrvatska' },
      { code: 'Ino', name: 'Uvoz/Izvoz' }
      // Add other countries as needed when API endpoints are available
    ];
  }

  onStartDateChange(event: any) {
    this.startDate = event;
  }

  onEndDateChange(event: any) {
    this.endDate = event;
  }

  isFormValid(): boolean {
    return !!this.selectedCountry && !!this.startDate && !!this.endDate;
  }

  toLocalAsUTC(date: Date): Date {
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return newDate;
  }

  async loadData() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    var result: any[] = [];
    try {
      switch (this.selectedCountry) {
        case 'BiH':
          result = await this.apiClient.biHAll3(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          break;
        case 'Srb':
          result = await this.apiClient.srbAll3(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          break;
        case 'Hrv':
          result = await this.apiClient.hrvAll3(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          break;
        case 'Ino':
          result = await this.apiClient.inoAll3(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          break;
        default:
          console.warn('No API endpoint for selected country:', this.selectedCountry);
          break;
      }

      this.gridData = result;

    } catch (error) {
      console.error('Error loading mobilna ponuda data:', error);
    } finally {
      this.loading = false;
    }
  }

  showCreateMobilnaPonuda() {
    this.createMobilnaPonudaPopupVisible = true;
  }

  async onMobilnaPonudaCreated(e: any) {
    await this.loadData();
  }

  async onMobilnaPonudaEdited(e: any) {
    await this.loadData();
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const mobilnaPonuda = e.row.data;

    try {
      await this.apiClient.smsPonudeDELETE(mobilnaPonuda.id);
       await this.apiClient.refreshCache();

      const index = this.gridData.findIndex(item => item.id === mobilnaPonuda.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting mobilna ponuda:', error);
    }
  }

  onEditClick(e: any) {
    this.selectedMobilnaPonuda = e.row.data;
    this.cdRef.detectChanges();
    this.editMobilnaPonudaPopupVisible = true;
  }
}